<template>
  <v-app v-if="showcaseList !== null" style="padding-top: 40px">
    <v-container grid-list-md>
      <p class="font-weight-bold display-2 mt-2 mb-0">Check what we have done for</p>
      <h1 class="font-weight-bold pb-3">{{ showcaseList.name }}</h1>
      <div style="border: 2px solid #1fb4cc; max-width: 150px" class="ml-2"></div>
      <p class="subheading mb-5 font-weight-bold mt-3 ml-2">
        {{ showcaseList.miniHeadingOne }}
        <span
          style="color: #1fb4cc"
        >{{ showcaseList.miniHeadingTwo }}</span>
      </p>
      <v-flex class="space-20 hidden-sm-and-up"></v-flex>
      <v-flex class="space-40 hidden-xs-only"></v-flex>
      <v-layout row wrap>
        <v-flex xs12 md7>
          <v-layout column style="padding-right: 20px; padding-top: 10px ">
            <v-img
              class="ml-3 mb-3"
              v-for="pic in showcaseList.showcaseList"
              lazy-src="/img/Ripple-200px.svg"
              :key="pic.uniquePortfolioID"
              :src="pic"
              style="border: 2px solid #2a2a2a "
            >
              <template v-slot:placeholder>
                <v-layout fill-height align-center justify-center ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-layout>
              </template>
            </v-img>
          </v-layout>
        </v-flex>
        <v-flex xs12 md5>
          <v-flex class="space-20 hidden-xs-only"></v-flex>
          <div style="position: -webkit-sticky;
  position: sticky;
  top: 5.5rem;">
            <v-card class="px-2" flat>
              <v-card-title class="font-weight-bold pt-0 pb-2" style="#303133">
                {{ showcaseList.name }}
                <br>
              </v-card-title>
              <p class="font-weight-light body-1 pl-3">{{ showcaseList.projectDescription }}</p>

              <v-card-title class="font-weight-bold pb-2" style="#303133">
                Date of Publication
                <br>
              </v-card-title>
              <p class="font-weight-light body-1 pl-3">{{ showcaseList.dateOfPublication }}</p>

              <v-card-title
                class="font-weight-bold pb-2"
                style="#303133"
                v-if="showcaseList.client"
              >
                Our Client
                <br>
              </v-card-title>
              <p
                class="font-weight-light body-1 pl-3"
                v-if="showcaseList.client"
              >{{ showcaseList.client }}</p>
              <p
                class="font-weight-bold body-1 pl-3"
                v-if="showcaseList.client"
              >{{ showcaseList.name }}</p>

              <v-card-title class="font-weight-bold pb-2" style="#303133">
                Category
                <br>
              </v-card-title>
              <p class="font-weight-light body-1 pl-3">{{ showcaseList.category }}</p>

              <div class="mt-3 pt-1 pb-1 ml-3" v-if="showcaseList.url">
                <v-btn
                  round
                  block
                  depressed
                  color="#1fb4cc"
                  class="mt-3 py-2"
                  :href="showcaseList.url"
                  target="_blank"
                >Visit Website</v-btn>
              </div>
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      showcaseList: null
    };
  },
  mounted() {
    if (this.$store.state.currentPortfolioViewed) {
      this.showcaseList = this.$store.state.currentPortfolioViewed;
    } else {
      this.$router.push({ name: "Portfolio" });
    }
  }
};
</script>

<style>
</style>